// Backoffice API endpoints
export const backofficeController = 'backoffice';
export const authController = `${backofficeController}/auth`;
export const usersController = `${backofficeController}/users`;

// Publishing API endpoints
export const publishingArticlesController = `${backofficeController}/publishing/articles`;
export const publishingMatchmakersController = `${backofficeController}/publishing/matchmakers`;
export const publishingMatchmakerSettingsController = `${backofficeController}/publishing/matchmakers/settings`;

// Legacy controllers (mantener por compatibilidad)
export const projectController = 'projects/';
export const clockingController = 'clockings/';
export const appUserController = 'users/';
export const systemLogsController = 'logs/';
export const aiConfigController = `${backofficeController}/ai-config`;

// Pagination constants
export const PER_PAGE_DEFAULT = 5;
export const INITIAL_PAGE = 1;
